const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phonePattern = /^[0-9+\-\s]{8,20}$/;

export function validateLoginIdentifier(value: string) {
  const identifier = value.trim();

  if (!identifier) {
    return 'Vui lòng nhập email hoặc số điện thoại.';
  }

  if (identifier.includes('@') && !emailPattern.test(identifier)) {
    return 'Email chưa đúng định dạng. Ví dụ: name@example.com.';
  }

  if (!identifier.includes('@') && !phonePattern.test(identifier)) {
    return 'Số điện thoại chưa đúng định dạng. Vui lòng nhập từ 8 đến 20 chữ số.';
  }

  return null;
}

export function validatePassword(value: string) {
  if (!value) {
    return 'Vui lòng nhập mật khẩu.';
  }

  if (value.length < 6) {
    return 'Mật khẩu cần có ít nhất 6 ký tự.';
  }

  return null;
}

export function authErrorMessage(error: unknown, fallback: string) {
  const message = error instanceof Error ? error.message : '';
  const normalized = message.toLowerCase();

  if (
    normalized.includes('email da duoc su dung') ||
    normalized.includes('so dien thoai da duoc su dung') ||
    normalized.includes('email đã được sử dụng') ||
    normalized.includes('số điện thoại đã được sử dụng')
  ) {
    return 'Tài khoản này đã được đăng ký. Vui lòng đăng nhập hoặc dùng email/số điện thoại khác.';
  }

  if (
    normalized.includes('mat khau khong dung') ||
    normalized.includes('khong dung') ||
    normalized.includes('mật khẩu không đúng') ||
    normalized.includes('không đúng')
  ) {
    return 'Email/số điện thoại hoặc mật khẩu không đúng.';
  }

  if (normalized.includes('email khong dung dinh dang') || normalized.includes('email chưa đúng định dạng')) {
    return 'Email chưa đúng định dạng. Vui lòng kiểm tra lại.';
  }

  if (
    normalized.includes('so dien thoai khong dung dinh dang') ||
    normalized.includes('số điện thoại chưa đúng định dạng')
  ) {
    return 'Số điện thoại chưa đúng định dạng. Vui lòng kiểm tra lại.';
  }

  if (normalized.includes('network request failed') || normalized.includes('failed to fetch')) {
    return 'Không kết nối được máy chủ. Vui lòng kiểm tra mạng hoặc địa chỉ API.';
  }

  return fallback;
}
